import { QStdButton } from "../CoreApp/QStdButton";
import { Globals } from "../CoreApp/Globals";

export function PAddStdButton(panel, xPos, yPos, width, height, label, cmdCode, narrowMargin) {
  var narrowMarginH = 4;
  var wsMgr = panel.fWSMgr;
  if (!wsMgr) wsMgr = Globals._wsMgr;
  var uicolors = wsMgr.GetUIColors();
  var stdButton = new QStdButton();
  stdButton.SetStdFillColor(uicolors.GetButtonFillColor());
  stdButton.SetFontColor(uicolors.GetHeaderTextColor());
  stdButton.PositionElement(xPos, yPos);
  stdButton.SizeElement(width, height);
  if (narrowMargin) stdButton.SetMarginH(narrowMarginH);
  stdButton.SetLabel(label);
  stdButton.SetCmdCode(cmdCode);
  panel.PushElement(stdButton);

  return stdButton;
}
